<template>
  <b-row>
    <b-col md="6" class="pr-0">
      <b-form-group vertical class="mb-1 mr-4" label="Точка:">
      <b-form-select :value="filterRestPoint" @input="changedRestPoint" :options="restPointOptions"></b-form-select>
    </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ACT from '../constants/vuexActions'
export default {
  name: 'RestPointFilter',
  props: {
    namespace: {
      type: String,
      required: true
    }
  },
  methods: {
    changedRestPoint (newVal) {
      this[ACT.UPDATE_SELECTED_RESTPOINT](newVal)
    },
    [ACT.UPDATE_SELECTED_RESTPOINT] (payload) {
      this.$store.dispatch(
        `${this.namespace}/${ACT.UPDATE_SELECTED_RESTPOINT}`,
        payload
      )
    }
  },
  computed: {
    restPointOptions () {
      return this.$store.getters[`${this.namespace}/restPointOptions`]
    },
    filterRestPoint () {
      return this.$store.getters[`${this.namespace}/filterRestPoint`]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RestPointFilter.vue